
import { defineComponent } from "vue";
import QuestionnaireCover from "./QuestionnaireCover.vue";
import Questionnaire from "./Questionnaire.vue";
import UserResponses from "./UserResponses.vue";

export default defineComponent({
  name: "ExerciseViewer",
  components: { UserResponses, Questionnaire, QuestionnaireCover }
});
